import axios, { AxiosRequestConfig } from 'axios';

import { AxiosServiceResponse, PagedList } from 'interfaces/general';

import { IParamsFilter } from './catalog';

const instance = axios.create({
  baseURL: `${process.env.GEOGRAPHY_SERVICE_ENDPOINT}/api/v1`,
  headers: {
    // SE ELIMINARIA CUANDO SE TENGA QA ESTABLE API KEY
    // 'Api-key': process.env.REQUEST_HEADER_API_KEY,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

export interface GetGlobalWorkZonesResponse {
  id?: number;
  name?: string;
  phoneCode?: number;
  codeIso?: string;
}

export interface GetStateZoneResponse {
  id?: number;
  countryId?: number;
  country?: string;
  name?: string;
  timeZoneName?: string;
  timeZoneDescriptionUtc?: string;
  timeZoneShiftUtc?: number;
}

export interface GetStateById {
  id?: number;
  name?: string;
  countryId?: number;
  country?: string;
  timeZoneName?: string;
  timeZoneDescriptionUtc?: string;
  timeZoneShiftUtc?: number;
  partnerId?: number;
  partner?: string;
}

export interface GetRegionZoneResponse {
  id?: number;
  countryId?: number;
  name?: string;
}

export interface MunicipalitiesResponse {
  id?: number;
  stateId?: number;
  name?: string;
}

export interface CodepostResponse {
  id?: number;
  postalCode?: string;
  locality?: string;
}

export interface Location {
  id?: number;
  client?: string;
  clientId: number;
  location: string;
  reference: string;
  address: string;
  priorityId: number;
  postalCode: string | number;
  postalCodeId: number;
  index?: number;
  locality: string;
  localityId?: number;
  municipality?: string;
  municipalityId?: number;
  countryState?: string;
  countryStateId?: number;
  state?: string;
  stateId?: number;
  region?: string;
  regionId?: number;
  lat?: number;
  long?: number;
  latitude?: number;
  longitude?: number;
  additionalInfo?: string;
  enabled?: boolean | number;
  reason?: string | null;
  createdDateTime?: Date;
  country?: string;
  dynamicFormFields?: { formFieldId: string | number; value: string }[];
  dynamicFormFieldsKeyVault?: { [key: string]: string };
  projectId?: number;
  projectName?: string;
  rowGuid?: string;
  hasAssignedTowers?: boolean;
  isTower?: boolean;
  isResponsible?: boolean;
}

export interface BulkLoadLocation {
  index: number;
  clientName: string;
  location: string;
  reference: string;
  address: string;
  priorityId: number | string;
  postalCodeName: string;
  localityName: string;
  lat: number | string;
  long: number | string;
  additionalInfo: string;
}

export interface BaseParams {
  text?: string;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  pageNumber?: number;
  isExport?: boolean;
}

export interface GetLocationsParams extends BaseParams {
  id?: number;
  clientId?: number;
  priorityId?: number;
  stateId?: number;
  regionId?: number;
  FormFieldId?: number | string;
  SearchDynamicFields?: boolean;
  DynamicFieldValue?: string;
  AdvancedSearchText?: string;
}

export interface LocationZone {
  id?: number;
  name?: string;
  countryRegionId?: number;
  countryRegionName?: string;
}

export interface GetLocalitiesByPostalCodeParams extends BaseParams {
  postalCode?: string | number;
  clientId?: string | number;
}

export interface Locality {
  id: number;
  name: string;
  postalCode?: string | number;
  postalCodeId?: number;
  municipalityId?: number;
  municipality?: string;
  stateId?: number;
  state?: string;
  regionId?: number;
  region?: string;
  countryId?: number;
  country?: string;
  clientId?: number;
}

export interface GetLocationsLogParams extends BaseParams {
  locationId?: number;
}

export interface GetTowersLogParams extends BaseParams {
  towerId?: number;
}

export interface LocationLog {
  id: number;
  dateTime: string;
  user: string;
  userName: string;
  movement: string;
  reason: string;
  updatedFields: string | null;
}

export interface GetClusteredLocationsParams {
  clientId?: number;
  projectId?: number;
  stateId?: number;
  location?: string;
  Text?: string;
  status?: number | boolean;
  priorityId?: number;
  regionId?: number;
  search?: string;
  text?: string;
  municipalityId?: string;
}

export interface ClusteredLocation {
  regionId?: number;
  region?: string;
  location?: string;
  latitude?: number;
  longitude?: number;
}

export interface BulkLoadLocationsRequest {
  locations: BulkLoadLocation[];
  withoutSaving: boolean;
}

export interface DisableLocation {
  index: number;
  client: string;
  location: string;
}

export interface DisableLocationsRequest {
  locations: DisableLocation[];
}

export interface ErrorLocation {
  index: number;
  errorMsg: string;
}

export interface DisabledLocation {
  index: number;
  location: string;
  client: string;
  updatedDateTime: string | null;
}

export interface DisableLocationsResponse {
  updatedDateTimeUtc: string | null;
  locationsDisabled: DisabledLocation[];
  errorLocations: ErrorLocation[];
}

export interface BulkLoadLocationsResponse {
  createdDateTimeUtc: string | null;
  locationsAdded: BulkLoadLocation[];
  errorLocations: ErrorLocation[];
}

export interface PostalCode {
  id: number;
  name: string;
  localityName: string;
  municipalityName: string;
  stateName: string;
}

export interface PostalCodeResponse {
  postalCodes: PostalCode[];
  totalCount: number;
}

export interface RegionsByCountryStatesIdsParams {
  countryStatesIds: string;
}

export interface RegionsByCountryStatesIdsResponse {
  id: number;
  name: string;
}

export interface PostalCodesResponse {
  id?: number;
  name?: string;
  localityId?: number;
  localityName?: string;
  municipalityId?: number;
  municipalityName?: string;
  stateId?: number;
  stateName?: string;
  countryId?: number;
  countryName?: string;
  enabled?: boolean;
}

export interface EditPostalCode {
  id?: number;
  name?: string;
  localityId?: number;
  localityName?: string;
  municipalityId?: number;
  municipalityName?: string;
  stateId?: number;
  stateName?: string;
  countryId?: number;
  countryName?: string;
  enabled?: boolean;
}

export interface HolidaysRequest {
  countryId: number;
}

export type Holiday = {
  date: Date;
  initTime?: string | null;
  endTime?: string | null;
};
export interface ICreateHolidays {
  countryId: number;
  holidayDays: Holiday[];
}

export interface Tower {
  projectName?: string;
  towerId?: number;
  locationId?: number;
  towerNumber?: string;
  requiredDocStatusId?: number;
  towerName?: string;
  towerModelId?: number;
  towerTypeId?: number;
  towerHeight?: number;
  affiliationCitronella1?: string;
  affiliationCitronella2?: string;
  isNew?: string;
  propertyOwner?: string;
  requiresAccessPermission?: boolean;
  paysRent?: boolean;
  rentAmount?: number;
  towerInstallationDate?: string;
  lastAdjustmentDate?: string;
  structureMaintenanceDate?: string;
  insurancePolicyNumber?: string;
  availableSpace?: string;
  documentMemory?: string;
  hadGrowth?: boolean;
  hasOfficialPermission?: boolean | number;
  otherObservations?: string;
  possibleGrowth?: boolean;
  hasSite?: string;
  canInstallShelter?: boolean;
  checkedCoordinatesAddress?: boolean;
  formatsCompleted?: boolean;
  reviewedCoordinatesSystem?: boolean;
  proposedMaintenanceYear?: number;
  responsibleId?: number;
  towerPropertyId?: number;
  hadGrowthDate?: string;
  enabled?: boolean;
}

export interface TowerByLocationId {
  id: number;
  towerName: string;
}

export interface TowerGeneralSearch extends BaseParams {
  towerId?: number;
  locationId?: number;
  towerNumber?: string;
  towerName?: string;
  towerModelId?: number;
}

export interface TowerLog {
  id: number;
  dateTime: string;
  movement: string;
  reason: string;
  user: string;
  updatedFields: string | null;
  userName: string;
}

export default {
  instance,
  Countries: {
    /**
     * SERVICIO PARA TRAER ZONAS HORARIAS
     *
     * @tags getTimeZones
     * @name getTimeZones
     * @request GET:/api/v1/Countries
     * @secure
     */
    getTimeZones: (
      params: {
        text?: string;
        orderColumn?: string;
        descending?: boolean;
        pageSize?: number;
        pageNumber?: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<unknown>>>({
        url: `/TimeZones`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * SERVICIO PARA REGIONES
     *
     * @tags getRegions
     * @name getRegions
     * @request GET:/api/v1/Countries
     * @secure
     */
    getRegions: (
      params: {
        text?: string;
        orderColumn?: string;
        descending?: boolean;
        pageSize?: number;
        pageNumber?: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<unknown>>>({
        url: `/Regions`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * SERVICIO PARA TRAER TODOS LOS PAISES
     *
     * @tags getAllCountries
     * @name getAllCountries
     * @request GET:/api/v1/Countries
     * @secure
     */
    getAllCountries: (
      params: {
        text?: string;
        orderColumn?: string;
        descending?: boolean;
        pageSize?: number;
        pageNumber?: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GetGlobalWorkZonesResponse>>
      >({
        url: `/Countries`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * SERVICIO PARA TRAER LOS ESTADOS DE CADA PAIS POR ID
     *
     * @tags getGlobalStatesByCityId
     * @name getGlobalStatesByCityId
     * @request GET:/api/v1/Countries/GetStatesByCountryId
     * @secure
     */
    getGlobalStatesByCityId: (
      params: {
        Id: number;
        text?: string;
        orderColumn?: string;
        descending?: boolean;
        pageSize?: number;
        pageNumber?: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GetStateZoneResponse>>
      >({
        url: `/Countries/GetStatesByCountryId`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * SERVICIO PARA TRAER LAS REGIONES DE CADA PAIS POR ID
     *
     * @tags getGlobalRegionsByCityId
     * @name getGlobalRegionsByCityId
     * @request GET:/api/v1/Countries/GetRegionsByCountryId
     * @secure
     */
    getGlobalRegionsByCityId: (
      params: {
        Id?: number;
        text?: string;
        orderColumn?: string;
        descending?: boolean;
        pageSize?: number;
        pageNumber?: number;
        All?: boolean;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GetRegionZoneResponse>>
      >({
        url: `/Countries/GetRegionsByCountryId`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * SERVICIO PARA TRAER LOS CODIGOS POSTALES DE CADA ESTADO POR EL ID DE LA MUNICIPALIDAD
     *
     * @tags getGlobalCodePostByMunicId
     * @name getGlobalCodePostByMunicId
     * @request GET:/api/v1/Municipalities/GetPostalCodesByMunicipalityId
     * @secure
     */
    getGlobalCodePostByMunicId: (
      data: {
        MunicipalityId: number;
        text?: string;
        orderColumn?: string;
        descending?: boolean;
        pageSize?: number;
        pageNumber?: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<CodepostResponse>>>(
        {
          url: `Municipalities/GetPostalCodesByMunicipalityId`,
          method: 'POST',
          data,
          ...config
        }
      )
  },
  // TODO: FALTA ENDPOINT PARA OBTENER TODOS LOS STATES SIN PAGINACION
  States: {
    /**
     * SERVICIO PARA TRAER LOS ESTADOS DE CADA REGION POR ID DE REGION
     *
     * @tags getGlobalStatesByCityId
     * @name getGlobalStatesByCityId
     * @request GET: States/GetCountryStateByRegion
     * @secure
     */
    getGlobalStatesByCityId: (
      params: {
        ids?: string;
        text?: string;
        orderColumn?: string;
        descending?: boolean;
        pageSize?: number;
        pageNumber?: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GetStateZoneResponse>>
      >({
        url: `States/GetCountryStateByRegion`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * SERVICIO PARA TRAER LAS MUNICIPALIDADES DE CADA ESTADO POR ID
     *
     * @tags getMunicipalitiesById
     * @name getMunicipalitiesById
     * @request GET:/api/v1/States/GetMunicipalitiesByState
     * @secure
     */
    getGlobalMunicipalitiesById: (
      params: {
        ids?: string | number;
        text?: string;
        orderColumn?: string;
        descending?: boolean;
        pageSize?: number;
        pageNumber?: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<MunicipalitiesResponse>>
      >({
        url: `States/GetMunicipalitiesByState`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Traer states
     * @tags States
     * @name getStates
     * @request GET:/api/v1/States
     * @secure
     */
    getStates: (params: BaseParams, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GetStateZoneResponse>>
      >({
        url: `/States`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Traer states by state Id
     * @tags States
     * @name getStatesById
     * @request GET:/api/v1/States/:id
     * @secure
     */
    getStatesById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<GetStateById>>({
        url: `/States/${id}`,
        method: 'GET',
        ...config
      }),

    /**
     * Agregar un Estado
     *
     * @tags CreateState
     * @name CreateState
     * @request POST:/api/v1/States/CreateState
     * @secure
     */
    CreateState: (data: unknown, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/States/CreateState`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Editar un Estado
     *
     * @tags UpdateState
     * @name UpdateState
     * @request PUT:/api/v1/States/UpdateState
     * @secure
     */
    UpdateState: (data: unknown, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/States/UpdateState`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * Eliminar un Estado
     *
     * @tags RemoveState
     * @name RemoveState
     * @request POST:/api/v1/States/RemoveState
     * @secure
     */
    deleteState: (data: unknown, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/States/RemoveState`,
        method: 'POST',
        data,
        ...config
      })
  },
  Locations: {
    /**
     * Agregar una Location
     *
     * @tags Location
     * @name createLocation
     * @request POST:/api/v1/Locations
     * @secure
     */
    createLocation: (data: Location, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/Locations`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Editar una Location
     *
     * @tags Location
     * @name updateLocation
     * @request PUT:/api/v1/Locations
     * @secure
     */
    updateLocation: (data: Location, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/Locations`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Eliminar una Location
     * @tags Location
     * @name deleteLocation
     * @request DELETE:/api/v1/Locations/{id}
     * @secure
     */
    deleteLocation: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/Locations/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Obtener Locations
     * @tags Location
     * @name getLocations
     * @request GET:/api/v1/Locations/GeneralSearch
     * @secure
     */
    getLocations: (
      params: GetLocationsParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<Location>>>({
        url: `/Locations/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Obtener ClusteredLocations
     * @tags Location
     * @name getClusteredLocations
     * @request GET:/api/v1/Locations/ClusteredLocations
     * @secure
     */
    getClusteredLocations: (
      params: GetClusteredLocationsParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ClusteredLocation>>
      >({
        url: `/Locations/ClusteredLocations`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Cargar Locations Masivamente
     * @tags Location
     * @name bulkLoadLocations
     * @request POST:/api/v1/Locations/BulkLoadLocations
     * @secure
     */
    bulkLoadLocations: (
      data: BulkLoadLocationsRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<BulkLoadLocationsResponse>>({
        url: `/Locations/BulkLoadLocations`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Inactivar Locations Masivamente
     * @tags Location
     * @name DisableLocations
     * @request POST:/api/v1/Locations/DisableLocations
     * @secure
     */
    disableLocations: (
      data: DisableLocationsRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<DisableLocationsResponse>>({
        url: `/Locations/DisableLocations`,
        method: 'POST',
        data,
        ...config
      })
  },
  PostalCodes: {
    /**
     * Obtener PostalCodes por Cliente
     * @tags PostalCode
     * @name getPostalCodesByClient
     * @request GET:/api/v1/PostalCodes/GetPostalCodeByClient
     * @secure
     */
    getPostalCodesByClient: (
      params: { clientId: string },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PostalCodeResponse>>({
        url: `/PostalCodes/GetPostalCodeByClient`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Obtiene todos lo codigos postales paginados
     * @tags PostalCode
     * @name generalSearchPostalCodes
     * @request GET:/api/v1/PostalCodes/SearchPostalCodes
     * @secure
     */
    generalSearchPostalCodes: (
      params: IParamsFilter,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<PostalCodesResponse>>
      >({
        url: `/PostalCodes/SearchPostalCodes`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Crear un codigo postal
     * @tags PostalCode
     * @name createNewPostalCode
     * @request POST:/api/v1/v1/PostalCodes
     * @secure
     */
    createNewPostalCode: (
      data: {
        name: string;
        localityName: string;
        municipalityId: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/PostalCodes`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Eliminar un codigo postal
     * @tags PostalCode
     * @name deletePostalCode
     * @request DELETE:/api/v1/PostalCodes?PostalCodeId=1
     * @secure
     */
    deletePostalCode: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/PostalCodes?PostalCodeId=${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Actualiza un codigo postal
     * @tags PostalCode
     * @name UpdatePostalCode
     * @request PUT:/api/v1/PostalCodes
     * @secure
     */
    UpdatePostalCode: (data: EditPostalCode, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/PostalCodes`,
        method: 'PUT',
        data,
        ...config
      })
  },
  Regions: {
    /**
     * Obtener Regions
     * @tags Regions
     * @name getRegions
     * @request GET:/api/v1/Regions
     * @secure
     */
    getRegionsList: (params: BaseParams, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ClusteredLocation>>
      >({
        url: `/Regions`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * Agregar una Region
     *
     * @tags Regions
     * @name createRegions
     * @request POST:/api/v1/Regions/CreateRegion
     * @secure
     */
    createRegions: (data: unknown, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/Regions/CreateRegion`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Editar una Regions
     *
     * @tags Regions
     * @name updateRegions
     * @request PUT:/api/v1/Regions/UpdateRegion
     * @secure
     */
    updateRegions: (data: unknown, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/Regions/UpdateRegion`,
        method: 'PUT',
        data,
        ...config
      }),

    /**
     * Eliminar una Region
     *
     * @tags Regions
     * @name createRegions
     * @request POST:/api/v1/Regions/RemoveRegion
     * @secure
     */
    deleteRegions: (data: unknown, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/Regions/RemoveRegion`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Obtener regiones por state
     * @tags Regions
     * @name getRegionsByCountryStatesIds
     * @request GET:/api/v1/Regions/GetRegionsByCountryStatesIds
     * @secure
     */
    getRegionsByCountryStatesIds: (
      params: RegionsByCountryStatesIdsParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<RegionsByCountryStatesIdsResponse[]>
      >({
        url: `/Regions/RegionsByCountryStatesIds`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * Obtener todas las regiones
     * @tags Regions
     * @name getAllRegions
     * @request GET:/api/v1/Regions/GetAllRegion
     * @secure
     */
    getAllRegions: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown[]>>({
        url: `/Regions/GetAllRegion`,
        method: 'GET',
        ...config
      })
  },
  tower: {
    //  DELETE, POST, PUT
    /**
     * Crear una torre
     * @tags Tower
     * @name createTower
     * @request POST:/api/v1/Tower
     * @secure
     */
    createTower: (data: Tower, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/Tower`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Editar una torre
     * @tags Tower
     * @name updateTower
     * @request PUT:/api/v1/Tower
     * @secure
     */
    updateTower: (data: Tower, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/Tower`,
        method: 'PUT',
        data,
        ...config
      }),

    /*
     * Eliminar una torre
     * @tags Tower
     * @name deleteTower
     * @request DELETE:/api/v1/Tower/{id}
     * @secure
     */
    deleteTower: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/Tower/${id}`,
        method: 'DELETE',
        ...config
      }),

    /*
     * Generalsearch de torre
     * @tags Tower
     * @name generalSearch
     * @request POST:/api/v1/Tower/GeneralSearch
     * @secure
     */
    generalSearch: (
      data: TowerGeneralSearch,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<Location>>>({
        url: `/Tower/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Obtener responsables de location por id
     * @tags Tower
     * @name getResponsiblesByLocationId
     * @request GET:/api/v1/Tower/GetResponsiblesByLocation/{idLocation}
     * @secure
     */
    getResponsiblesByLocationId: (
      idLocation: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{ id: number; fullName: string }[]>
      >({
        url: `/Tower/GetResponsiblesByLocation/${idLocation}`,
        method: 'GET',
        ...config
      }),

    /**
     * getTowerByLocationId
     * @tags Tower
     * @name getTowerByLocationId
     * @request GET:/api/v1/Tower/GetByLocation/{locationId}
     * @secure
     */
    getTowerByLocationId: (
      locationId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<Tower>>({
        url: `/Tower/${locationId}`,
        method: 'GET',
        ...config
      })
  },
  towersLog: {
    /**
     * Obtener TowersLog
     * @tags TowersLog
     * @name getTowersLog
     * @request GET:/api/v1/TowersLog
     * @secure
     */
    getTowersLog: (
      params: GetTowersLogParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<TowerLog>>>({
        url: `/TowersLog`,
        method: 'GET',
        params,
        ...config
      })
  },
  LocationZones: {
    /**
     * Obtener LocationZones
     * @tags LocationZone
     * @name getLocationZones
     * @request GET:/api/v1/LocationZones/GetLocationZones
     * @secure
     */
    getLocationZones: (params: BaseParams, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<LocationZone>>>({
        url: `/LocationZones/GetLocationZones`,
        method: 'GET',
        params,
        ...config
      })
  },
  Localities: {
    /**
     * Obtener Localities
     * @tags Localities
     * @name getLocalitiesByPostalCode
     * @request GET:/api/v1/Localities/GetLocalitiesByPostalCode
     * @secure
     */
    getLocalitiesByPostalCode: (
      params: GetLocalitiesByPostalCodeParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<Locality>>>({
        url: `/Localities/GetLocalitiesByPostalCode`,
        method: 'GET',
        params,
        ...config
      })
  },
  LocationsLog: {
    /**
     * Obtener LocationsLog
     * @tags LocationsLog
     * @name getLocationsLog
     * @request GET:/api/v1/LocationsLog
     * @secure
     */
    getLocationsLog: (
      params: GetLocationsLogParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<LocationLog>>>({
        url: `/LocationsLog`,
        method: 'GET',
        params,
        ...config
      })
  },
  Holidays: {
    /**
     * Obtiene los dias Festivos de un Pais
     * @tags HolidayDay
     * @name getHolidays
     * @request GET:/api/v1/HolidayDay
     * @secure
     */

    getHolidays: (params: HolidaysRequest, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Holiday[]>>({
        url: `/HolidayDay`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * Guarda los dias Festivos de un Pais
     * @tags HolidayDay
     * @name createHolidaysByCountry
     * @request POST:/api/v1/HolidayDay
     * @secure
     */
    createHolidaysByCountry: (
      data: ICreateHolidays,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<Location>>({
        url: `/HolidayDay`,
        method: 'POST',
        data,
        ...config
      })
  }
};
